<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import AwesomeMask from "awesome-mask";

export default {
  name: "UserDetailsAffiliateForm",
  props: {
    validation: Object
  },
  directives: {
    mask: AwesomeMask
  },
  async mounted () {
    await this.$store.dispatch('courses/fetchAll')
    if(this.isUserWizard && this.$p(['RECRUITER'])) {
      this.updateAffiliateForm({ field: 'RECRUITER_ID', value: this.recruiterOptions[0].value})
    }
  },
  data() {
    return {
      selectedManager: null,
      selectedRecruiter: null
    };
  },
  computed: {
    ...mapState("users", {
      userForm: state => state.userForm,
      addressForm: state => state.addressForm,
      affiliateForm: state => state.affiliateForm,
      canEdit: state => state.userModal.canEdit,
      isUserWizard: state => state.userWizardModal.open
    }),
    ...mapGetters("users", ["managerOptions", "recruiterOptions", 'affiliateCourseIds']),
    ...mapGetters({
      stateOptions: "stateOptions", 
      courseOptions: "courses/courseOptions"
    }),
    affiliateCodeHelper () {
      return (!this.$p(["ADMIN","MANAGER"],'or')) ? 'Assigned by Manager' : ''
    }
  },
  methods: {
   
    ...mapMutations("users", [
      "updateUserForm",
      "updateAddressForm",
      "updateAffiliateForm"
    ]),
    ...mapMutations(["closeDetails"]),
    ...mapActions(['courses/fetchCourses'])
  }
};
</script>

<template>
  <div class="q-pb-xl layout-padding">
    <div class="row">
      <h5 class="q-pa-md col-12" style="padding-bottom:0">
        <q-icon color="primary" name="fa fa-building"></q-icon> Affiliate Information
      </h5>
      <q-field
        class="q-pa-md col-4"
        error-label="Affiliate Name is required"
        :error="validation.affiliateForm.AFFILIATE_NAME.$error"
      >
        <q-input
          float-label="Affiliate Name"
          v-model="affiliateForm.AFFILIATE_NAME"
          :after="[
            {icon: 'flag', color: 'red', class: 'exclamation-circle-icon', condition: validation.affiliateForm.AFFILIATE_NAME.$invalid},
            {icon: 'fa fa-check', condition: !validation.affiliateForm.AFFILIATE_NAME.$invalid}
          ]"
          :disable="!canEdit"
          @blur="validation.affiliateForm.AFFILIATE_NAME.$touch"
        ></q-input>
      </q-field>
      <q-field
        class="q-pa-md col-4"
        error-label="Affiliate Code is required"
        :error="validation.affiliateForm.AFFILIATE_CODE.$error"
        :helper="affiliateCodeHelper"
      >
        <q-input
          float-label="Affiliate Code"
          v-model="affiliateForm.AFFILIATE_CODE"
          :after="[
            {icon: 'flag', color: 'red', class: 'exclamation-circle-icon', condition: validation.affiliateForm.AFFILIATE_CODE.$invalid},
            {icon: 'fa fa-check', condition: !validation.affiliateForm.AFFILIATE_CODE.$invalid}
          ]"
          :disable="!canEdit || !$p(['ADMIN', 'MANAGER'], 'or')"
          @blur="validation.affiliateForm.AFFILIATE_CODE.$touch"
        ></q-input>
      </q-field>

      <q-field
        class="q-pa-md col-4"
        error-label="Either FEIN or SSN is required"
        :error="validation.affiliateForm.FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER.$error"
      >
        <q-input
          float-label="Federal Employer Identification #"
          v-mask="'99-9999999'"
          :value="affiliateForm.FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER"
          :after="[
            {icon: 'flag', color: 'red', class: 'exclamation-circle-icon', condition: validation.affiliateForm.FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER.$invalid},
            {icon: 'fa fa-check', condition: !validation.affiliateForm.FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER.$invalid}
          ]"
          @blur="validation.affiliateForm.FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER.$touch"
          @keyup.stop="updateAffiliateForm({ field: 'FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER', value: $event.target.value })"
          :disable="!canEdit"
        ></q-input>
      </q-field>
      <div class="col-12 q-px-md q-pb-md"><b>Available Credits</b><br />
      <b>${{affiliateForm.AVAILABLE_CREDITS}}</b></div>
    </div>
    <div class="row">
      <!-- <q-field class="q-pa-md col-4">
        <q-select
          float-label="Status"
          :value="detailsForm.status"
          :options="statusOptions"
          @change="val => updateAffiliateForm({ field: 'status', value: val })"
        />
      </q-field>-->
    </div>
    <div class="row">
      <h6 class="q-pa-md col-12" style="padding-bottom:0">
        <q-icon color="primary" name="fa fa-user-plus"></q-icon> Recruiter Information
      </h6>
      <q-field
        class="q-pa-md col-4"
        error-label="Student Processing Fee is required"
        :error="validation.affiliateForm.STUDENT_PROCESSING_FEE.$error"
      >
        <q-input
          float-label="Student Processing Fee"
          v-model="affiliateForm.STUDENT_PROCESSING_FEE"
          :before="[{icon: 'attach_money'}]"
          :after="[
            {icon: 'flag', color: 'red', class: 'exclamation-circle-icon', condition: validation.affiliateForm.STUDENT_PROCESSING_FEE.$invalid},
            {icon: 'fa fa-check', condition: !validation.affiliateForm.STUDENT_PROCESSING_FEE.$invalid}
          ]"
          @blur="validation.affiliateForm.STUDENT_PROCESSING_FEE.$touch"
          :disable="!canEdit"
          required
        ></q-input>
      </q-field>

      <q-field class="q-pa-md col-4">
        <q-select
          float-label="Recruiter"
          v-model="affiliateForm.RECRUITER_ID"
          :options="recruiterOptions"
          @input="val => updateAffiliateForm({ field: 'RECRUITER_ID', value: val })"
          filter
          autofocus-filter
          clearable
          :disable="!canEdit || $p(['RECRUITER'])"
        />
      </q-field>
      <q-field
        class="q-pa-md col-4"
        error-label="Recruiter fee must be less than student processing fee"
        :error="validation.affiliateForm.RECRUITER_FEE.$error"
      >
        <q-input
          float-label="Recruiter Fee"
          :value="affiliateForm.RECRUITER_FEE"
          :after="[
            {icon: 'flag', color: 'red', class: 'exclamation-circle-icon', condition: validation.affiliateForm.RECRUITER_FEE.$invalid},
            {icon: 'fa fa-check', condition: !validation.affiliateForm.RECRUITER_FEE.$invalid}
          ]"
          @keyup.stop="updateAffiliateForm({ field: 'RECRUITER_FEE', value: $event.target.value })"
          :disable="!canEdit"
          @blur="validation.affiliateForm.RECRUITER_FEE.$touch"
          required
        ></q-input>
      </q-field>
    </div>
    <div class="row">
      <!-- <q-field class="q-pa-md col-4">
       <q-select
        float-label="Manager"
        v-model="affiliateForm.MANAGER_ID"
        :options="managerOptions"
        @input="val => updateAffiliateForm({ field: 'MANAGER_ID', value: val })"
         filter autofocus-filter
        :disable="!canEdit"
        />
      </q-field>-->
    </div>
    <div class="row">
      <h6 class="q-pa-md col-12" style="padding-bottom:0">
        <q-icon color="primary" name="fa fa-info"></q-icon> Affiliate Contact
      </h6>
      <q-field class="q-pa-md col-4">
        <q-input
          float-label="Contact Name"
          :value="affiliateForm.CONTACT_NAME"
          @keyup.stop="updateAffiliateForm({ field: 'CONTACT_NAME', value: $event.target.value })"
          :disable="!canEdit"
          required
        ></q-input>
      </q-field>
      <q-field class="q-pa-md col-4">
        <q-input
          float-label="Contact Phone"
          type="tel"
          v-mask="'999-999-9999'"
          :value="affiliateForm.CONTACT_PHONE"
          @keyup.stop="updateAffiliateForm({ field: 'CONTACT_PHONE', value: $event.target.value })"
          :disable="!canEdit"
          required
        ></q-input>
      </q-field>
      <q-field class="q-pa-md col-4">
        <q-input
          float-label="Contact Email"
          :value="affiliateForm.CONTACT_EMAIL"
          :disable="!canEdit"
          @keyup.stop="updateAffiliateForm({ field: 'CONTACT_EMAIL', value: $event.target.value })"
        ></q-input>
      </q-field>
    </div>
    <div class="row">
      <h6 class="q-pa-md col-12" style="padding-bottom:0">
        <q-icon color="primary" name="fa fa-book"></q-icon> Courses
      </h6>
      <q-field
        class="q-pa-md col-12"
        :error="validation.affiliateForm.COURSES.$error"
        error-label="Must assign at least one course to Affiliate!">
        <q-select
          chips
          multiple
          float-label="Courses"
          :value="affiliateCourseIds"
          :options="courseOptions"
          :after="[
            {icon: 'flag', color: 'red', class: 'exclamation-circle-icon', condition: validation.affiliateForm.COURSES.$invalid},
            {icon: 'fa fa-check', condition: !validation.affiliateForm.COURSES.$invalid}
          ]"
          filter
          autofocus-filter
          :disable="!canEdit || $p(['RECRUITER', 'MANAGER'])"
          @input="affiliateCourseIds => this.updateAffiliateForm({
            field: 'COURSES',
            value: affiliateCourseIds.map(courseId => { 
              return { COURSE_ID: courseId } 
            })
          })"
        />
      </q-field>
    </div>
    <div class="row" v-if="$p(['ADMIN'])">
      <h6 class="q-pa-md col-12" style="padding-bottom:0">
        <q-icon color="primary" name="fa fa-print"></q-icon> Print Permissions
      </h6>
      <div class="q-pa-md col-12">
        <q-checkbox
          label="Can Print Certificate Copies"
          :value="affiliateForm.PRINT_PERMISSION"
          v-if="$p(['ADMIN'])"
          :true-value="1"
          :false-value="0"
          indeterminate-icon="check_box_outline_blank"
          @input="val => this.updateAffiliateForm({
            field: 'PRINT_PERMISSION',
            value: val
          })"
        />
      </div>
    </div>
    <div class="row" v-if="$p(['ADMIN'])">
      <h6 class="q-pa-md col-12" style="padding-bottom:0">
        <q-icon color="primary" name="fa fa-file"></q-icon> Data Entry
      </h6>
      <div class="q-pa-md col-12">
        <q-checkbox
          label="School Entered"
          :value="affiliateForm.SCHOOL_ENTERED"
          v-if="$p(['ADMIN'])"
          :true-value="1"
          :false-value="0"
          indeterminate-icon="check_box_outline_blank"
          @input="val => this.updateAffiliateForm({
            field: 'SCHOOL_ENTERED',
            value: val
          })"
        />
      </div>
    </div>
  </div>
</template>

<style>
.exclamation-circle-icon {
  font-size: 1.4rem !important;
}
</style>
